import React from 'react'
import { Spin } from 'antd'
import cl from 'classnames'

import Icon from '../Icon'

import styles from './styles.module.scss'

type SpinnerProps = React.HTMLAttributes<HTMLSpanElement> &
	React.RefAttributes<HTMLSpanElement> & {
		isFullWindow?: boolean
		isFullContainer?: boolean
		isBrandLogo?: boolean
		spinning?: boolean
		children?: JSX.Element
		spinnerText?: string
		wrapperClassName?: string
	}

const Spinner: React.FC<SpinnerProps> = ({
	className,
	isFullWindow = false,
	isFullContainer = true,
	isBrandLogo = false,
	spinning,
	children,
	spinnerText,
	wrapperClassName,
	...props
}) => {
	const IconComponent = isBrandLogo ? (
		<Icon className={cl(className, styles.logoSpinner)} type="logo" {...props} />
	) : (
		<Spin className={cl(className, styles.spinner)} {...props} />
	)

	if (children) {
		return (
			<Spin
				spinning={spinning}
				className={wrapperClassName}
				indicator={
					<>
						{IconComponent}
						<div className={styles.spinnerText}>{spinnerText}</div>
					</>
				}
			>
				{children}
			</Spin>
		)
	}

	if (isFullWindow) {
		return <div className={styles.windowWrapper}>{IconComponent}</div>
	}

	if (isFullContainer) {
		return <div className={cl(styles.containerWrapper, wrapperClassName)}>{IconComponent}</div>
	}

	return IconComponent
}
export default Spinner
